export const useQuantitySuggestion = () => {
  const getQuantity = (weight: number, qty: number) => {
    const totalWeight = weight * qty
    const nearestKilo = Math.ceil(totalWeight / 1000)
    const recommendedQty = (nearestKilo * 1000) / weight

    return Math.floor(recommendedQty)
  }

  return { getQuantity }
}
